module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['dots', {
      'dots--active': _vm.active
    }],
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('span', {
    staticClass: "dot",
    style: ({
      'background-color': _vm.org.custom_color3 == null ? '' : _vm.org.custom_color3
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    style: ({
      'background-color': _vm.org.custom_color3 == null ? '' : _vm.org.custom_color3
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "dot",
    style: ({
      'background-color': _vm.org.custom_color3 == null ? '' : _vm.org.custom_color3
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f27de21"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Dots.vue
// module id = 242
// module chunks = 2